import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const BoxProductAttributesSettingsScheme = z.object({
  product_attribute_product_id:
    themeScheme.SettingSkuScheme.default("").catch(""),
});

export const BoxProductAttributesMessagesScheme = z.object({
  box_content_dropdown_placeholder: themeScheme.MessageScheme.default(""),
});
